module.exports = __webpack_public_path__ + "static/media/menu.dd38b95e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menu.svg
// module id = 460
// module chunks = 0